/* eslint-disable import/no-cycle */
import { setBreadcrumb } from './index';
import Parent from '../views/Parent.vue';

import BulkGenerate from '@/views/merchant-tools/BulkGenerate.vue';
import ListOutlet from '@/views/merchant-tools/ListOutlet.vue';
import MappingQrisTap from '@/views/merchant-tools/mapping-qristap/MappingQrisTap.vue';

const merchantTools = {
  path: '/merchant-tools',
  name: 'Merchant Tools',
  meta: {
    title: 'BNI QRIS - Merchant Tools',
    appBarTitle: 'Merchant Tools',
  },
  component: Parent,
  children: [
    {
      path: '/merchant-tools/bulk-generate-qr-statis',
      meta: {
        title: 'BNI QRIS - Bulk Generate QR Statis',
        appBarTitle: 'Bulk Generate QR Statis',
        breadcrumbs: () => [
          setBreadcrumb('Merchant Tools', '/merchant-tools', true),
          setBreadcrumb('Bulk Generate QR Statis', '/merchant-tools/bulk-generate-qr-statis'),
        ],
      },
      component: BulkGenerate,
      name: 'Bulk Generate QR Statis',
    },
    {
      path: '/merchant-tools/outlet-management',
      meta: {
        title: 'BNI QRIS - Outlet Management',
        appBarTitle: 'Outlet Management',
        breadcrumbs: () => [
          setBreadcrumb('Merchant Tools', '/merchant-tools', true),
          setBreadcrumb('Outlet Management', '/merchant-tools/outlet-management'),
        ],
      },
      component: ListOutlet,
      name: 'Outlet Management',
    },
    {
      path: '/merchant-tools/mapping-qristap',
      meta: {
        title: 'BNI QRIS - Mapping QrisTap',
        appBarTitle: 'Mapping QrisTap',
        breadcrumbs: () => [
          setBreadcrumb('Merchant Tools', '/merchant-tools', true),
          setBreadcrumb('Mapping QrisTap', '/merchant-tools/mapping-qristap'),
        ],
      },
      component: MappingQrisTap,
      name: 'Mapping QrisTap',
    },
  ],

};

export default merchantTools;
